"use strict";
const _ = require('lodash');
const omsEvents = require('./events/oms/events');
const supplierGatewayEvents = require('./events/supplier-gateway/events');
const endCustomerGatewayEvents = require('./events/end-customer-gateway/events');
const crmEvents = require('./events/crm/events');
const inventoryEvents = require('./events/inventory/events');
const getEntityName = require('../getEntityName');
const events = {
    ...omsEvents,
    ...crmEvents,
    ...supplierGatewayEvents,
    ...endCustomerGatewayEvents,
    ...inventoryEvents,
};
const prettierEventNames = event => {
    switch (event.eventName) {
        case 'FORTNOX_UPDATED':
            return 'Ordersystem uppdaterat';
        case 'FORTNOX_EXTERNAL_UPDATED':
            return 'Fortnox har mottagit uppdateringar';
        case 'FORTNOX_ERROR':
            return `Fel vid skickande till fortnox: ${_.get(JSON.parse(event.error), 'message')}`;
        default:
            return [
                _.get(events, event.eventName, event.eventName),
                getEntityName(event, 'eventParams'),
            ]
                .filter(x => x)
                .join(': ');
    }
};
module.exports = { ...events, prettierEventNames };
